import endpoints from '../api/endpoints'
import { FetchKey, useFetchCollectionWithPost } from '../api/fetchHooks'
import { SortOrder } from '../types/filter'
import type { AssessmentTemplate } from '../types/resourceExplorer'
import { ONE_MINUTE_MS } from '@app/src/wf-constants'

export const useAssessmentTemplatesWithSections = () => {
  const { items: assessmentTemplates, isLoading } = useFetchCollectionWithPost<AssessmentTemplate>({
    endpoint: endpoints.assessmentTemplateCollection,
    key: FetchKey.AssessmentTemplateCollection,
    payload: {
      filter: [],
      include: ['Sections'],
      sort: { target: 'name', order: SortOrder.ASCENDING },
    },
    options: {
      staleTime: ONE_MINUTE_MS,
    },
  })

  return {
    assessmentTemplates,
    isLoading,
    templateOptions:
      assessmentTemplates?.map(t => ({
        label: t.name,
        value: t.id,
      })) ?? [],
  }
}
